import { useContext, useLayoutEffect, useEffect } from 'react';
import { CoreContext } from '../context/index.js';
import { setCatalogId } from '../utils/logger.js';
import '../utils/logToSlack.js';

/**
 * Hook to initialize the global catalogId for logger.
 * This hook should be called at the application root level to ensure the
 * global catalogId is available for all logger calls.
 */
const useCatalogId = () => {
    const { data: { siteConfig: { catalogId }, }, } = useContext(CoreContext);
    // Use useLayoutEffect for earlier execution in the React lifecycle
    // Fall back to useEffect for SSR compatibility
    const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
    // Set the catalogId as early as possible
    useIsomorphicLayoutEffect(() => {
        if (catalogId) {
            setCatalogId(catalogId);
        }
    }, [catalogId]);
    return catalogId;
};

export { useCatalogId as default };
//# sourceMappingURL=useCatalogId.js.map
